/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { DataReportCommand } from './data-report.command';
import { Store } from '@ngxs/store';
import { inject } from '@angular/core';

export function dataReportFactory() {
    const command = new DataReportCommand();
    command.setDependencies({
        store: inject(Store),
    });
    return command;
}
